import LoadingIndicator from "components/shared/LoadingIndicator";
import moment from "moment-timezone";
import Maintenance from "pages/Maintenance";
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom";
import { FadeLoader } from "react-spinners";
import { signup } from "Routes/paths";
import { getAccountSettingList } from "store/services/accountSettingService";
import { getBannerSettings, getBasicSettings } from "store/services/appService";
import { getPractitionerSettings } from "store/services/authService";
import { logout } from "store/services/authService";

const WrappedApp = (WrappedComponent) => {
  return (props) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const maintenanceConfig = useSelector((state) => state.App.basicSettings?.maintenance_schedule?.client);
    
    const [ready, setReady] = useState(false);
    const isAuthenticated = useSelector((state) => state.Auth.isAuthenticated);

    useEffect(() => {
      async function init() {
        try {
          // On signup, logout if already logged in
          const isSignup = location.pathname === signup;
          const accessToken = localStorage.getItem("access_token");
          const signupKey = new URLSearchParams(location.search).get("token");

          if (isSignup && accessToken && signupKey) {
            // Logout before anything else
            await dispatch(logout());
          }

          // App-wide settings
          await Promise.all([
            dispatch(getBasicSettings()),
            dispatch(getBannerSettings()),
          ]);

          setReady(true);
        } catch (err) {
          console.error("Error in WrappedApp init:", err);
          setReady(true);
        }
      }

      init();
    }, []);

    useEffect(() => {
      if(isAuthenticated) {
        dispatch(getAccountSettingList());
        dispatch(getPractitionerSettings());
      }
    }, [isAuthenticated]);

    // Wait until ready
    if (!ready) {
      return (
        <div>
          <div className="main-loader_">
            <FadeLoader color="#f4694b" size={300} />
          </div>
        </div>
      )
    }

    // Show maintenance screen if active
    if (
      maintenanceConfig?.enabled === "yes" &&
      maintenanceConfig?.start_date &&
      maintenanceConfig?.end_date &&
      moment().isBefore(moment(maintenanceConfig?.end_date)) &&
      moment().isAfter(moment(maintenanceConfig?.start_date))
    ) {
      return <Maintenance config={maintenanceConfig} />;
    }

    return (
      <WrappedComponent {...props} />
    )
  };
};

export default WrappedApp;
